import { type DocNode } from '@atlaskit/adf-schema';
import { Fragment, Node as PMNode, type Schema } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';

const isRootNode = (schema: Schema, node: PMNode) => node.type === schema.nodes.doc;

export const adfResponseToFragment = ({
	schema,
	adfResponse,
	adfResponseNodeWrappers,
}: {
	adfResponse: DocNode | DocNode['content'][number];
	adfResponseNodeWrappers?: string[];
	schema: Schema;
}): Fragment => {
	const initialNode = PMNode.fromJSON(schema, adfResponse);
	// If we're not in the root node make the current node a fragment, otherwise
	// we may lose information about the container while streaming.
	let fragment =
		!isRootNode(schema, initialNode) && fg('platform_editor_ai_aifc_patch_ga')
			? Fragment.from(initialNode)
			: initialNode.content;

	const wrappers = adfResponseNodeWrappers ? [...adfResponseNodeWrappers] : [];
	while (wrappers.length > 0) {
		const wrapperName = wrappers.pop();
		if (
			wrapperName &&
			fragment.content.length === 1 &&
			fragment.content[0].type.name === wrapperName
		) {
			fragment = fragment.content[0].content;
		} else {
			break;
		}
	}

	return fragment;
};
